import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Language, useLanguage } from "../../../i18n/useLanguage";
import { CompareResults } from "../../../queries/useBuildComparison";
import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { gridCellClass } from "./TireComparisonGrid";
import { selectPricingContext } from "./selectPricingContext";
import { useShouldRenderPricing } from "./useShouldRenderPricing";

type ProductInfoProps = {
  part: TirePartItem;
  quantity: 2 | 4;
};

const selectPromotionText = (
  part: TirePartItem,
  quantity: 2 | 4,
  language: Language,
): string | undefined => {
  const { promotionPricingText, promotionText } = selectPricingContext(
    part.partPricing.primaryPart.price,
    quantity,
  );
  return (
    promotionPricingText?.[language] ||
    promotionPricingText?.en ||
    promotionText?.[language] ||
    promotionText?.en
  );
};

export const hasPropmotions = (
  items: CompareResults[],
  quantity: 2 | 4,
  language: Language,
): boolean =>
  items.some((item) =>
    Boolean(selectPromotionText(item.part, quantity, language)),
  );

export const Promotion: FunctionComponent<ProductInfoProps> = ({
  part,
  quantity,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  const text = selectPromotionText(part, quantity, language);
  return (
    <div className={gridCellClass}>
      {useShouldRenderPricing(part) && text ? (
        <>{text}</>
      ) : (
        t("compare.notAvailable")
      )}
    </div>
  );
};

/**
 * @see docs/worklog/TW-866-compare-promo/rfc.md
 * @see docs/worklog/TW-866-compare-promo/tfc.md
 */
